module.exports = __webpack_public_path__ + "img/t1-black.ceb15f64.png";